import React from 'react';
import { formatDateToDDMMYYYY } from '../../../utils/formatDate';
import PropTypes from 'prop-types';

const DatatableRow = React.memo(({
  row,
  idx,
  cols,
  colWidths,
  checkboxColumn,
  rowIdField,
  onRowClick,
  onRowDoubleClick,
  draggingKey,
  selectedRows,
  toggleSelectRow
}) => {
  const isSelected = selectedRows.has(row[rowIdField]);
  const rowEven = i => idx % 2 === 0 ? 'datatable-row-even' : 'datatable-row-odd';

  return (
    <tr
      key={row[rowIdField] ?? `${rowIdField}-${idx}`}
      className={isSelected ? 'datatable-row-selected' : rowEven(idx)}
      style={{ cursor: (onRowClick || onRowDoubleClick) ? 'pointer' : undefined }}
      onClick={onRowClick ? () => onRowClick(row) : undefined}
      onDoubleClick={onRowDoubleClick ? () => onRowDoubleClick(row) : undefined}
    >
      {checkboxColumn && (
        <td className="datatable-td-checkbox">
          <div className="d-flex align-items-center justify-content-center">
            <input 
              type="checkbox" 
              checked={isSelected}
              onChange={() => toggleSelectRow(row[rowIdField])}
              onClick={e => e.stopPropagation()}
              style={{ cursor: 'pointer', width: 16, height: 16 }}
            />
          </div>
        </td>
      )}
      {cols.map((col, colIdx) => {
        let value = col.selector ? col.selector(row) : row[col.key];
        if (col.type === 'date' && value) value = formatDateToDDMMYYYY(value);
        const dataAlign = col.dataAlign || 'left';

        const isDragging = draggingKey === col.key;

        const isStickyRight = col.stickyRight;
        const cellClass = `datatable-td-cell ${isStickyRight ? "datatable-td-sticky-right" : ""}`;

        let tdStyle = {
          textAlign: dataAlign,
          width: colWidths[col.originalIdx] || undefined,
          maxWidth: colWidths[col.originalIdx] || undefined,
          minWidth: col.minWidth || undefined,
          borderRight: colIdx < cols.length - 1 ? "1px solid #14406e22" : undefined,
          opacity: isDragging ? 0.4 : 1,
        };
        return (
          <td key={col.key} className={cellClass} style={tdStyle} title={typeof value === 'string' ? value : ''}>
            {col.render ? col.render(value, row) : value ?? ""}
          </td>
        );
      })}
    </tr>
  );
});

DatatableRow.propTypes = {
  row: PropTypes.object.isRequired,
  idx: PropTypes.number,
  cols: PropTypes.array.isRequired,
  colWidths: PropTypes.array,
  checkboxColumn: PropTypes.bool,
  rowIdField: PropTypes.string.isRequired,
  onRowClick: PropTypes.func,
  onRowDoubleClick: PropTypes.func,
  draggingKey: PropTypes.string,
  selectedRows: PropTypes.instanceOf(Set).isRequired,
  toggleSelectRow: PropTypes.func.isRequired
};
export default DatatableRow;
